<ui-card [headline]="headline$|async" [cardToolBarItems]="menuItems$|async" [isExpanded]="true">
  <div *ngIf="itemData$|async;let itemData;">
    <ui-table *ngIf="itemData.length > 0" (rowClicked)="onRowClicked($event)" [data]="itemData" fxLayout="column">
      <ui-table-column name="workflowName" headerName="{{getName()}}"></ui-table-column>
      <ui-table-column name="status" headerName="Status" type="icon" [iconValueMap]="statusMap" [width]="70"></ui-table-column>
      <ui-table-column name="scheduledDt" headerName="Scheduled On" type="date" cellFilter="date:'MM-dd-yyyy hh:mm:ss a'"></ui-table-column>
    </ui-table>
  </div>
</ui-card>
